import { Node } from "@tiptap/core"

export const EmbedExtension = Node.create({
  name: "embed",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      src: { default: null }
    }
  },

  parseHTML() {
    return [
      {
        tag: "div[data-embed]",
        getAttrs: (el) => ({ src: el.getAttribute("data-src") })
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      { "data-embed": "", "data-src": HTMLAttributes.src, class: "custom-embed" },
      "Cargando..."
    ]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("div")
      dom.classList.add("w-full", "h-full", "relative", "aspect-video")

      const iframe = document.createElement("iframe")
      iframe.src = node.attrs.src
      iframe.classList.add("w-full", "h-full", "absolute", "inset-0", "border-0")
      iframe.allowFullscreen = true
      dom.appendChild(iframe)

      const overlay = document.createElement("div")
      overlay.classList.add("absolute", "inset-0", "z-10")
      dom.appendChild(overlay)

      return { dom }
    }
  },

  addCommands() {
    return {
      setEmbed: (options) => ({ commands }) => {
        return commands.insertContent({ type: "embed", attrs: { src: options.src } })
      }
    }
  }
})
